import React from 'react';
import { render } from 'react-dom';

import StyleForm from './style-form';

import './style.scss?global';

render(<StyleForm />, document.getElementById('style-form-root'));
